import { gql } from '@apollo/client';
import { useGraphql } from 'utils/hooks/useGraphql';

export const queryHasApprovedBusinessTemplates = gql`
  query queryHasApprovedBusinessTemplates {
    hasApprovedBusinessTemplates
  }
`;

export const useQueryHasApprovedBusinessTemplates = (options?: Record<string, any>) => {
  const { data } = useGraphql(queryHasApprovedBusinessTemplates, options);

  return {
    hasApprovedBusinessTemplates: data?.hasApprovedBusinessTemplates,
  };
};
